import { NavLink } from 'react-router-dom'
import clsx from 'clsx'

import BetaTag from '../BetaTag'
import Count from 'components/Count/Count'
import NewTag from '../NewTag/NewTag'

import s from './MenuItem.module.css'

export type MenuItemProps = {
  label: string
  path: string
  icon?: React.ReactNode
  count?: number
  children?: MenuItemProps[]
  onClick?: () => void
  isShrunk?: boolean
  dataId?: string
  countInLabel?: number
  beta?: boolean
  new?: boolean
}

export const MenuItem = (item: MenuItemProps) => (
  <li
    className={clsx(s.item, {
      [s.expand]: item.isShrunk,
    })}
  >
    <NavLink
      to={item.path}
      className={s.navLink}
      activeClassName={s.navLinkActive}
      onClick={item.onClick}
      data-tooltip={item.label}
      data-id={item.dataId}
      exact={true}
    >
      {item.icon && <span className={s.navLinkIcon}>{item.icon}</span>}
      {!item.isShrunk && (
        <span className={s.label}>
          {item.label} {!!item.countInLabel && `(${item.countInLabel})`}
          {item.beta && <BetaTag />}
          {item.new && <NewTag />}
        </span>
      )}
      {!!item.count &&
        (item.isShrunk ? (
          <span className={s.chatDot} />
        ) : (
          <Count count={item.count} />
        ))}
    </NavLink>
  </li>
)
